/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from "react";
import classname from "classnames";
import Button from "../Button";
import IconButton from "../Button/IconButton";
import CustomTree from "../CustomTree/CustomTree";
import { shallowEqual, useSelector } from "react-redux";
import { isEmpty } from "lodash-es";
import {
  setTreeDataByParts,
  matchEmployee,
  // findSelectedNode,
} from "../../utils/treeData";
import PerfectScrollbar from "react-perfect-scrollbar";
import CloseButton from "../../assets/images/icon/close-btn.svg";
import SearchIcon from "../../assets/images/icon/search-icon2.svg";
import { cloneDeep, forEach, get, isNull, isNumber } from "lodash";
import Profile from "../Profile";
import Input from "../Input";
import { classnames } from "../../utils/text";
import Icon from "../Icon";
import { getGroups } from "../../apis/companies/group";

import { sortBy, includes } from "lodash";

const SearchEmployee = (props) => {
  const {
    selectedList,
    setSelectedList,
    callback,
    defaultSelected,
    // options,
    title,
    isSingle,
    isPartView,
    customEmployees,
    submit,
    cancel,
    isTax = false,
    isExceptLeave = false,
    isOpen
  } = props;

  const {
    user,
    storeCompany,
    storeParts,
    storeEmployees,
    storeGrades,
    storeGroups,
    managerEmployees,
    managerGrades,
    managerGroups,
    managerParts,
  } = useSelector(
    (store) => ({
      user: store.Profile.user,
      storeCompany: store.Profile.company,
      storeParts: store.Data.parts,
      storeEmployees: store.Data.employees,
      storeGrades: store.Data.grades,
      storeGroups: store.Data.groups,
      managerEmployees: store.Data.managerEmployees,
      managerGrades: store.Data.managerGrades,
      managerGroups: store.Data.managerGroups,
      managerParts: store.Data.managerParts

    }),
    shallowEqual
  );

  const [company, setCompany] = useState([]);
  const [parts, setParts] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [_employees, _setEmployees] = useState([]);
  const [grades, setGrades] = useState([]);
  const [groups, setGroups] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [tabList] = useState([
    { label: "부서별 보기", action: setActiveTab },
    { label: "직급별 보기", action: setActiveTab },
    { label: "그룹별 보기", action: setActiveTab },
    ...[isPartView ? { label: "부서 보기", action: setActiveTab } : {}]
  ]);
  const [treeData, setTreeData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [reformGroups, setReformGroups] = useState([]);

  const [reCheck, setReCheck] = useState(false);

  useEffect(() => {
    setCompany(isTax ? storeCompany?.taxCompany : storeCompany);
    setParts(isTax ? managerParts : storeParts);


    setGrades(isTax ? managerGrades : storeGrades);
    setGroups(isTax ? managerGroups : storeGroups);

    const _employees = isTax ? managerEmployees : storeEmployees;
    _setEmployees(isExceptLeave ? _employees.filter(f => isNull(f.leaveDate) && f.office > 0) : _employees);

  }, [
    isExceptLeave,
    isTax,
    storeCompany,
    storeParts,
    storeEmployees,
    storeGrades,
    storeGroups,
    managerEmployees,
    managerGrades,
    managerGroups,
  ]);

  useEffect(() => {
    if (isOpen && !isEmpty(groups) && !isEmpty(employees)) {
      let reform = cloneDeep(groups);
      forEach(reform, (obj) => {
        getGroups(obj.idx, { isTax }).then((res) => {
          const employeeList = res.data.group.companyGroupEmployees;
          obj.children = employeeList.map((e) => {
            const targetEmployee = employees.find(employee => employee.idx === get(e, 'employeeIdx')) || {};
            return {
              title: get(e, 'employee.name'),
              key: get(e, 'employeeIdx'),
              isEmployee: true,
              isChecked: true,
              profileImg: targetEmployee.profileImg || "",
              code: targetEmployee.code,
            };
          });
        });
      });
      setReformGroups(reform);
    }
  }, [groups, employees]);

  useEffect(() => {
    if (!isEmpty(customEmployees)) {
      setEmployees(
        customEmployees.map((e) => ({
          title: e.name,
          key: e.idx,
          ...e,
        }))
      );
    } else {
      setEmployees(
        _employees.map((e) => ({
          title: e.name,
          key: e.idx,
          ...e,
        }))
      );
    }
  }, [_employees, customEmployees]);

  const _setSearchText = (e) => {
    setSearchText(e.target.value);
  };
  const reset = () => {
    // setTreeData([])
    _setSelectedList();
    // setActiveTab(0)
  };

  const _setSelectedList = (employees = [], type = "employees") => {

    //console.log('_setSelectedList')

    switch (type) {
      case "parts":
        if (isSingle) {
          const parts = employees[employees.length - 1];
          if (parts) {
            employees = [parts];
          }
          if (employees && employees[0] && !employees[0].isPart) {
            return;
          }
        }
        employees = sortBy(employees, 'code');
        setSelectedList(employees);
        setCheckedKeys(employees.map((e) => e.key));
        break;
      default:
        if (isSingle) {
          const _employee = employees[employees.length - 1];
          if (_employee) {
            employees = [_employee];
          }
          if (employees && employees[0] && !employees[0].isEmployee) {
            return;
          }
        }
        employees = sortBy(employees, 'code');
        setSelectedList(employees);
        setCheckedKeys(employees.map((e) => e.key));
        break;
    }
  };

  useEffect(() => {
    if (!callback) {
      reset();
    }
  }, [callback]);

  useEffect(() => {
    _setTreeData();
  }, [activeTab, parts, company, employees, user, grades, reformGroups]);

  const _setTreeData = () => {
    let treeData = [];
    let _company = cloneDeep(company);
    const employeesSort = [];
    const leaveEmployees = [];
    forEach(sortBy(employees, 'code'), item => {
      if (!includes(item.name, "(퇴사)")) {
        employeesSort.push(item);
      } else {
        leaveEmployees.push(item);
      }
    });
    forEach(leaveEmployees, item => {
      employeesSort.push(item);
    });

    switch (activeTab) {
      case 1:
        _setSelectedList();
        if (!isEmpty(grades)) {
          _company = {
            title: get(_company, "name"),
            key: "company",
            children: [
              ...matchEmployee(
                [
                  ...grades.map((grade) => ({
                    ...grade,
                    title: grade.name,
                    key: `grade-${grade.idx}`,
                    children: [],
                  })),
                  { title: "미지정", key: "unspecified", children: [] },
                ],
                employeesSort,
                "grade"
              ),
            ],
          };
        } else {
          _company = {
            title: get(_company, "name"),
            key: "company",
            children: [
              ...matchEmployee(
                [{ title: "미지정", key: "unspecified", children: [] }],
                employeesSort,
                "grade"
              ),
            ],
          };
        }
        treeData.push(_company);
        break;
      case 2:
        _setSelectedList();
        if (!isEmpty(reformGroups)) {
          _company = {
            title: get(_company, "name"),
            key: "company",
            children: [
              ...reformGroups.map((group) => {
                const childrens = sortBy(group.children, "code");
                return {
                  title: group.name,
                  key: group.idx,
                  children: (childrens || []).map((children) => {
                    const target = employeesSort.find((e) => { return e.key === children.key; });
                    return {
                      ...children,
                      ...target
                    };
                  }),
                };
              }),
            ],
          };
        }
        treeData.push(_company);
        break;
      case 3:
        _setSelectedList();
        _company = {
          title: get(_company, "name"),
          key: "company",
          // isChecked: true,
          children: [...setTreeDataByParts(parts, true)],
        };
        treeData.push(_company);
        break;
      default:
        // 0
        _setSelectedList();
        if (!isEmpty(parts)) {
          _company = {
            title: get(_company, "name"),
            key: "company",
            children: [
              ...matchEmployee(
                [
                  ...setTreeDataByParts(parts),
                  { title: "미지정", key: "unspecified", children: [] },
                ],
                employeesSort
              ),
            ],
          };
        } else {
          _company = {
            title: get(_company, "name"),
            key: "company",
            children: [
              ...matchEmployee(
                [{ title: "미지정", key: "unspecified", children: [] }],
                employeesSort
              ),
            ],
          };
        }
        treeData.push(_company);
        break;
    }
    setTreeData(treeData);
  };

  // 외부에서 선택된 것들 주입
  useEffect(() => {
    if (!isEmpty(defaultSelected)) {

      const _selectedList = [];
      defaultSelected.forEach((employee) => {
        if (isNumber(employee)) {
          employee = _employees.find(e => e.idx === Number(employee));
        }
        if (!employee) {
          return;
        }
        _selectedList.push({
          key: employee.idx,
          title: employee.name,
          ...employee,
        });
      });

      setTimeout(() => {
        _setSelectedList(_selectedList);
      }, 500);
    }
  }, [defaultSelected]);

  const handleOnChecked = (keys, event) => {
    //console.log('handleOnChecked')
    const checkedNodes = [];

    if (activeTab < 3) {
      forEach(event.checkedNodes, (check) => {
        if (check.isEmployee) {
          checkedNodes.push(check);
        } else return;
      });
    } else if (activeTab === 3) {
      forEach(event.checkedNodes, (check) => {
        if (check.isPart) {
          checkedNodes.push(check);
        } else return;
      });
    }

    if (isEmpty(checkedNodes)) {
      _setSelectedList();
    } else {
      if (activeTab < 3) {
        _setSelectedList(checkedNodes);
      } else {
        _setSelectedList(checkedNodes, "parts");
      }
    }
  };

  const handleRemove = (data) => {
    _setSelectedList(
      selectedList.filter((selected) => selected.idx !== data.idx)
    );
    setReCheck(true);
  };

  const handleRemoveAll = () => {
    _setSelectedList();
    setReCheck(true);
  };

  const searchEmployeeResult = useCallback(
    ({ name, gradeName, partName }) => {
      const targetText = name + gradeName + partName;

      return targetText.includes(searchText);
    },
    [searchText]
  );

  const isSelectedEmployee = (employee) => {
    return !!selectedList.find((e) => e.idx === employee.idx);
  };
  return (
    <div className="search-employee-filter">
      {title && (
        <div className="search-employee-header">
          <h5 className="search-employee-title">{title}</h5>
        </div>
      )}
      <div className="search-employee-body">
        <div className="search-text-wrap">
          <Icon src={SearchIcon} />
          <Input
            name={"search-text"}
            placeholder={"직급, 소속, 이름 검색"}
            value={searchText}
            onChange={_setSearchText}
            className={"search-text-input"}
          />
          {searchText && (
            <IconButton
              className="search-input-delete-icon"
              icon={CloseButton}
              onClick={() => setSearchText("")}
            />
          )}
        </div>
        {/* 탭 */}
        {searchText && (
          <ul className="tab-list">
            <li className="tab-item">
              "<span className="color-main-100">{searchText}</span>" 검색결과
            </li>
          </ul>
        )}
        {!searchText && (
          <ul className="tab-list">
            {tabList.map(({ label, action }, idx) => (
              <li
                key={idx}
                className={classname("tab-item", { active: activeTab === idx })}
              >
                <a
                  onClick={() => {
                    action(idx);
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        )}
        {/* 트리 구조 */}
        {searchText && (
          <div className="search-result-container">
            <ul className="search-result-wrap">
              {employees.map((employee, idx) => (
                <li
                  className={classnames("text-search-employee", {
                    alive: searchEmployeeResult(employee),
                    hide: !searchEmployeeResult(employee),
                    selected: isSelectedEmployee(employee),
                  })}
                  key={idx}
                  onClick={() => {
                    if (isSelectedEmployee(employee)) {
                      handleRemove(employee);
                    } else {
                      // TODO
                      _setSelectedList([...selectedList, { ...employee, isEmployee: true }]);
                    }
                  }}
                >
                  <Profile
                    isPreview={false}
                    data={employee}
                    className="inline-block"
                    onClick={() => { }}
                  />{" "}
                  <span className="search-result-part-name">
                    {employee.partName}
                  </span>{" "}
                  <span className="search-result-grade-name">
                    {employee.gradeName}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className={classnames("tree-view-wrap", { selected: !isEmpty(selectedList) })}>
          <PerfectScrollbar>
            {!isEmpty(treeData) ? (
              <CustomTree
                treeData={treeData}
                setTreeData={setTreeData}
                checkable
                checkedKeys={checkedKeys}
                selectable={false}
                handleChecked={handleOnChecked}
                checkStrictly={true}
                isSingle={isSingle}
                reCheck={reCheck}
                setReCheck={setReCheck}
              />
            ) : (
              <>준비 중입니다.</>
            )}
          </PerfectScrollbar>
        </div>
        {/* 선택된 인원 */}
        {!isEmpty(selectedList) && (
          <div className="selected-list-wrap">
            <div className="list-wrap">
              <PerfectScrollbar>
                {!isEmpty(selectedList) &&
                  selectedList.map((data, idx) => (
                    <span key={idx} className="selected-tag">
                      {data.title}
                      <IconButton
                        className="close-btn"
                        icon={CloseButton}
                        onClick={(e) => handleRemove(data)}
                      />
                    </span>
                  ))}
              </PerfectScrollbar>
            </div>

            {!isEmpty(selectedList) && (
              <div className="remove-btn-wrap">
                <div className="backgound"></div>
                <Button
                  className="remove-all"
                  label="전체삭제"
                  color="text"
                  onClick={handleRemoveAll}
                />
              </div>
            )}
          </div>
        )}
      </div>
      {(cancel || submit) && (
        <div className="search-employee-footer">
          <div className="search-button-wrap">
            {cancel && (
              <Button className="button" color={"text"} onClick={cancel}>
                취소
              </Button>
            )}
            {submit && (
              <Button onClick={submit} className="button">
                선택완료
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchEmployee;
